<template>
    <div aria-disabled="true" class="switch-button" @click="toggle" :class="{ 'switch-on': click }">
        <div class="switch-handle"></div>
    </div>
</template>

<script>
export default {
	name: 'CustomSwitch',
    props: {
        switchState: {
            type: Boolean,
            default: false,
        },
        toggleSwitch: {
            type: Function,
            require: true,
        }
    },
    methods: {
       toggle(){
            // this.$emit('toggleSwitch');
            // console.log("클릭?")
            this.toggleSwitch();
       }
    },
    computed: {
        click() {
            return this.switchState;
        }
    },
};
</script>

<style>
.switch-button {
    position: relative;
    display: inline-block;
    width: 38px;
    height: 20px;
    background-color: #ccc;
    border-radius: 35px;
    cursor: pointer;
}
.switch-on {
    background-color: #6ebf44;
}
.switch-handle {
    position: absolute;
    top: 3px;
    left: 3px;
    width: 14px;
    height: 14px;
    background-color: #fff;
    border-radius: 30px;
    transition: all 0.2s ease;
}
.switch-on .switch-handle {
    transform: translateX(18px);
}
</style>